<template>
</template>

<script>

export default {
  name: 'MitMenuAdmin',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
